module.exports = __webpack_public_path__ + "img/生活服务.44b314bb.jpg";